import {useEffect, useRef, useState} from 'react';
import buildVersion from '../generated/buildVersion.json';

const VERSION_CHECK_INTERVAL_MS = 60000;

function useNewVersionAvailable(intervalMs = VERSION_CHECK_INTERVAL_MS) {
    const [updateAvailable, setUpdateAvailable] = useState(false);
    const currentVersionRef = useRef(buildVersion.version);

    useEffect(() => {
        let isMounted = true;

        const checkVersion = async () => {
            try {
                const publicUrl = process.env.PUBLIC_URL || '';
                const response = await fetch(`${publicUrl}/version.json?_=${Date.now()}`, {
                    cache: 'no-store',
                });
                const data = await response.json();

                if (!isMounted || !data.version) {
                    return;
                }

                if (data.version !== currentVersionRef.current) {
                    setUpdateAvailable(true);
                }
            } catch (error) {
                // Network errors should not interrupt the user.
            }
        };

        checkVersion();
        const intervalId = setInterval(checkVersion, intervalMs);

        return () => {
            isMounted = false;
            clearInterval(intervalId);
        };
    }, [intervalMs]);

    return updateAvailable;
}

export default useNewVersionAvailable;
